import DashAppUrl from '../models/DashApp/DashAppUrl';
import request from './requestService';

class DashAppService {
  private readonly BaseUrl = `/DashApp`;

  public async getDashAppUrl(companyId: string, productId: string): Promise<DashAppUrl> {
    const response = await request.get(`${this.BaseUrl}/GetDashAppUrl?companyId=${companyId}&productId=${productId}`);
    return response.data;
  }
}

const dashAppService = new DashAppService();

export default dashAppService;
